import { defineComponent as t, createElementBlock as o, openBlock as n, normalizeClass as r, renderSlot as s } from "vue";
const l = ["aria-controls", "aria-selected", "tabindex"], p = /* @__PURE__ */ t({
  __name: "SectionFilterButton",
  props: {
    selected: { type: Boolean },
    controls: {}
  },
  setup(a) {
    return (e, c) => (n(), o("button", {
      "aria-controls": e.controls ?? "",
      "aria-selected": !!e.selected,
      class: r(["hover:bg-b-2 flex w-fit cursor-pointer items-center rounded p-1 px-2 text-center font-medium whitespace-nowrap has-[:focus-visible]:outline", { "text-c-1 pointer-events-none": e.selected }]),
      role: "tab",
      tabindex: e.selected ? 0 : -1,
      type: "button"
    }, [
      s(e.$slots, "default")
    ], 10, l));
  }
});
export {
  p as default
};
